import JWTDecode from 'jwt-decode';

const storage = window.localStorage;
const tokenKey = 'token';


export function setToken(token) {
  return storage.setItem(tokenKey, token);
}

export function getToken() {
  return storage.getItem(tokenKey);
}

export function revokeToken() {
  return storage.removeItem(tokenKey);
}

export function isLoggedIn() {
  if (getToken()) {
    const decoded = JWTDecode(getToken());
    return (Date.now() / 1000) < decoded.exp;
  }

  return false;
}

export function getValueFromToken(key, defaultValue = null) {
  if (getToken()) {
    const decoded = JWTDecode(getToken());
    return (Date.now() / 1000) < decoded.exp && decoded[key];
  }
  return defaultValue;
}

export function isSuperuser() {
  return getValueFromToken('superuser', false);
}

export function getUsername() {
  return getValueFromToken('username', '');
}

export function getUserId() {
  return getValueFromToken('user_id');
}
